import { Routes, Route } from "react-router-dom";
import { Outlet, Navigate } from "react-router-dom";
import LandingPage from "./pages/landing";
import Login from "./pages/login";
import PrivacyPolicy from "./pages/privacy_policy";
import Register from "./pages/register";
import SubscribePage from "./pages/subscribe";
import Logout from "./pages/logout";
import Home from "./pages/home";
import MatchesPage from "./pages/matches";
import ChatPage from "./pages/chat";
import ProfileEditPage from "./pages/profile";
import ProfileViewPage from "./pages/view_profile";
import { useUser } from "./global_state";

const PrivateRoutes = () => {
  const token = localStorage.getItem("auth_token");
  if (!token) {
    return <Navigate to="/login/" />;
  }
  return <Outlet />;
};

const ProfileRequiredRoutes = () => {
  const [user, setUser] = useUser();
  if (user && !user.is_profile_completed) {
    return <Navigate to="/app/profile/" />;
  }

  return <Outlet />;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<LandingPage />} />
    {/* AUth */}
    <Route path="/login/" element={<Login />} />
    <Route path="/logout/" element={<Logout />} />
    <Route path="/register/" element={<Register />} />
    <Route path="/privacy" element={<PrivacyPolicy />} />
    <Route element={<PrivateRoutes />} path="/app/">
      <Route path="subscribe/" element={<SubscribePage />} />
      <Route element={<ProfileRequiredRoutes />} path="">
        <Route path="home/" element={<Home />} />
        <Route path="matches/" element={<MatchesPage />} />
        <Route path="chat/:id" element={<ChatPage />} />
      </Route>

      {/* Authenticated routes */}
      <Route path="profiles/:id" element={<ProfileViewPage />} />
      <Route path="profile/" element={<ProfileEditPage />} />
    </Route>
  </Routes>
);

export default AppRoutes;
